import customAxiosInterceptor from "../customAxiosInterceptor";
import { ErrorResponse } from "../index";

// https://infocomp.ba/assets/politika_privatnosti.html
// https://infocomp.ba/assets/uslovi_i_odredbe.html
// https://infocomp.ba/assets/najcesca_pitanja.html
// https://infocomp.ba/assets/o_nama.html
export const fetchAssetsThunk = async (
  asset: string,
  thunkAPI: any
): Promise<any | ReturnType<typeof thunkAPI.rejectWithValue>> => {
  try {
    const response = await customAxiosInterceptor.get<any>(`/asset`, {
      params: { name: asset },
    });

    return {data: response.data.data, asset: asset};
  } catch (error: any) {
    const errorResponse = error.response.data as ErrorResponse;
    return thunkAPI.rejectWithValue(errorResponse.msg);
  }
};
